<template>
  <div>
    <dialog-box />

    <api-errors />

    <cmh-landing-page-step comingFromOresWebSite :lang="lang" @canContinue="canContinue = $event" @next="nextStep" />
  </div>
</template>

<script lang="ts">
import { Component } from 'vue-property-decorator'
import { Form } from '@/views/forms/Form'
import { googleService } from '@/services'
import CmhLandingPageStep from '@/components/steps/new-connection-cmh/CmhLandingPageStep.vue'
import DialogBox from '@/components/shared/DialogBox.vue'
import ApiErrors from '@/components/display/ApiErrors.vue'
import { pixelFacebookService } from '@ores/vue-library'

@Component({
  components: {
    CmhLandingPageStep,
    DialogBox,
    ApiErrors
  },
  name: 'landing-page-ores'
})
export default class LandingPageOres extends Form {
  //#region [Methods]
  public mounted() {
    this.onLangChanged(this.lang)
    googleService.includeMapScript(this.$el, this.$settings.googleMapsApiKey)
    pixelFacebookService.trackViewContent({
      content_ids: ['CmhForm'],
      content_name: 'Landing Page - Ores',
      content_type: 'product'
    })
  }
  //#endregion
}
</script>

<style scoped></style>
